<template>
  <router-view
    class="payments_container"
    :selectedTermProps="selectedTerm"
    :selectedProductProps="selectedProduct"
    :termProps="term"
    :productProps="product"
    :activeSyncProps="activeSync"
  />
</template>
<script>
import _API from '@/api';

export default {
  name: 'Payments',
  data() {
    return {
      activeSync: false,
      selectedTerm: {type : 3},
      selectedProduct: {seqProduct: 0},
      term: [
        {
          id: 'yearly',
          type: 3,
          trans: 'Yearly',
          sale : 'SAVE 10%'
        },
        {
          id: 'monthly',
          type: 2,
          trans: 'Monthly'
        }
      ],
      product: []
    }
  },
  created() {
    this.getProductListFromServer();
  },
  methods: {
    // TODO 해당 국가에서 판매할 수 있는 상품이 없을 경우의 화면 예외 처리
    getProductListFromServer() {
      this.activeSync = true;
      _API.PAYMENT.getProductList()
      .then(({data}) => {
        if (data.isSuccess) {
          this.product = data.productList;
        }
        this.activeSync = false;
      })
    }
  }
}
</script>
<style lang="scss">
.payments_container {
  background: var(--white);

  .row {
    padding: 80px 30px;

    &.background_ivory {
      background: var(--grey10);
    }
    .contents_area {
      width: 100%;
      min-width: 964px;
      max-width: 1024px;
      margin: 0 auto;
    }
  }
}
</style>